import MultiValueMap from '../multiValueMap';
import z from 'zod';

export type IndexIssueRedundant = z.infer<typeof IndexIssueRedundant>;
export type IndexIssue = z.infer<typeof IndexIssue>;
export type IndexRecommendationDebug = z.infer<typeof IndexRecommendationDebug>;
export type IndexRecommendationRemoveRedundant = z.infer<typeof IndexRecommendationRemoveRedundant>;
export type IndexRecommendation = z.infer<typeof IndexRecommendation>;
export type IndexAnalysisResult = z.infer<typeof IndexAnalysisResult>;

export const IndexIssueRedundant = z.object({
  type: z.literal('redundant'),
  message: z.string(),
  coveredBy: z.array(z.string()),
});

export const IndexIssue = z.union([IndexIssueRedundant]);

export const IndexRecommendationDebug = z.object({
  optionsConsidered: z.number(),
  timeMs: z.number(),
});

export const IndexRecommendationRemoveRedundant = z.object({
  type: z.literal('removeRedundant'),
  message: z.string(),
  removeIndexes: z.array(z.string()),
  savedSize: z.number(),
  savedSizePerIndex: z.map(z.string(), z.number()),
  debug: IndexRecommendationDebug.optional(),
});

export const IndexRecommendation = z.union([IndexRecommendationRemoveRedundant]);

export const IndexAnalysisResult = z.object({
  issues: z.instanceof(MultiValueMap<string, IndexIssue>),
  recommendations: z.array(IndexRecommendation),
});
